/* Insert the tour iframe only when someone asks for it. A 360 tour is a heavy third-party
   embed, and most visitors will never open it, so it must not be in the critical path. */
(function () {
  function boot() {
    document.querySelectorAll('.bm-wh-frame').forEach(function (frame) {
      if (frame.dataset.bmReady) return;
      frame.dataset.bmReady = '1';
      var btn = frame.querySelector('.bm-wh-play');
      var url = frame.getAttribute('data-tour');
      if (!btn || !url) return;
      btn.addEventListener('click', function () {
        var f = document.createElement('iframe');
        f.src = url;
        f.title = frame.getAttribute('data-title') || 'Warehouse tour';
        f.loading = 'lazy';
        f.allowFullscreen = true;
        f.setAttribute('allow', 'fullscreen; accelerometer; gyroscope; magnetometer; xr-spatial-tracking');
        f.setAttribute('referrerpolicy', 'no-referrer-when-downgrade');
        frame.appendChild(f);
        frame.classList.add('is-live');
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
}());
